import { defineComponent as R, ref as n, computed as m, toRef as C, resolveComponent as f, openBlock as S, createElementBlock as c, normalizeClass as k, createVNode as u, mergeProps as v, withCtx as d, renderSlot as O, normalizeProps as B, guardReactiveProps as T } from "vue";
import { usePopoverState as b } from "@onereach/ui-components-common/hooks";
import { O as j } from "./OrFilterPopover-C8lXb-hJ.mjs";
import { O as z } from "./OrFilterTrigger-zfcgyC7C.mjs";
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const A = [], E = R({
  name: "OrFilter",
  components: {
    OrFilterPopover: j,
    OrFilterTrigger: z
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    triggerProps: {
      type: Object,
      default: () => ({})
    },
    popoverProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: [
    "update:state",
    "open",
    "close",
    "apply",
    "reset"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, o) {
    const i = n(), l = m(() => [
      "or-filter-v3",
      ...A
    ]), t = n(), a = m(() => {
      var g;
      return (g = t.value) == null ? void 0 : g.root;
    }), s = n(), { state: p, open: r, close: P, toggle: y } = b(C(e, "isOpen"), o.emit);
    function $() {
      o.emit("apply");
    }
    function F() {
      o.emit("reset");
    }
    return {
      root: i,
      rootStyles: l,
      trigger: t,
      triggerRoot: a,
      popover: s,
      state: p,
      open: r,
      close: P,
      toggle: y,
      apply: $,
      reset: F
    };
  }
});
function N(e, o, i, l, t, a) {
  const s = f("OrFilterTrigger"), p = f("OrFilterPopover");
  return S(), c("div", {
    ref: "root",
    class: k(e.rootStyles)
  }, [
    u(s, v({
      ref: "trigger",
      "is-open": e.state === "open"
    }, e.triggerProps, {
      onClick: o[0] || (o[0] = (r) => e.toggle()),
      onReset: o[1] || (o[1] = (r) => e.reset())
    }), null, 16, ["is-open"]),
    u(p, v({
      ref: "popover",
      "is-open": e.state === "open",
      trigger: e.triggerRoot
    }, e.popoverProps, {
      "onUpdate:state": o[2] || (o[2] = (r) => r === "open" ? e.open() : e.close()),
      onApply: o[3] || (o[3] = (r) => e.apply()),
      onReset: o[4] || (o[4] = (r) => e.reset())
    }), {
      actions: d((r) => [
        O(e.$slots, "actions", B(T(r)))
      ]),
      default: d(() => [
        O(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["is-open", "trigger"])
  ], 2);
}
const H = /* @__PURE__ */ w(E, [["render", N]]);
export {
  H as O
};
//# sourceMappingURL=OrFilter-C8d3OmGK.mjs.map
